module.exports = __webpack_public_path__ + "image/about_logo4.png";